import {
  makeVuexList,
  mergeModules,
  makeVuexProp,
} from '../../utils/vuexUtils';

let moduleName = 'app';

let { module: szervezetek, storeTypes: szervezetekStoreTypes } = makeVuexList({
  namespace: moduleName,
  listName: 'szervezetek',
  key: 'Id',
});
let {
  module: hirKategoriak,
  storeTypes: hirKategoriakStoreTypes,
} = makeVuexList({
  namespace: moduleName,
  listName: 'hirKategoriak',
  key: 'Id',
});
let { module: fooldalData, storeTypes: fooldalDataStoreTypes } = makeVuexProp({
  namespace: moduleName,
  propName: 'fooldalData',
});
let {
  module: fooldalDataDesktop,
  storeTypes: fooldalDataDesktopStoreTypes,
} = makeVuexProp({
  namespace: moduleName,
  propName: 'fooldalDataDesktop',
});
let { module: appSettings, storeTypes: appSettingsStoreTypes } = makeVuexProp({
  namespace: moduleName,
  propName: 'appSettings',
  value: {},
});
let {
  module: isDrawerOpened,
  storeTypes: isDrawerOpenedStoreTypes,
} = makeVuexProp({
  namespace: moduleName,
  propName: 'isDrawerOpened',
  value: false,
});
let { module: user, storeTypes: userStoreTypes } = makeVuexProp({
  namespace: moduleName,
  propName: 'user',
  value: null,
});
let {
  module: pageTransition,
  storeTypes: pageTransitionStoreTypes,
} = makeVuexProp({
  namespace: moduleName,
  propName: 'pageTransition',
  value: {
    name: 'router-view',
    mode: 'in-out',
  },
});
let { module: linkek, storeTypes: linkekStoreTypes } = makeVuexList({
  namespace: moduleName,
  listName: 'linkek',
  key: 'Id',
});
let AppStoreTypes = {
  szervezetek: szervezetekStoreTypes,
  hirKategoriak: hirKategoriakStoreTypes,
  fooldalData: fooldalDataStoreTypes,
  fooldalDataDesktop: fooldalDataDesktopStoreTypes,
  appSettings: appSettingsStoreTypes,
  isDrawerOpened: isDrawerOpenedStoreTypes,
  user: userStoreTypes,
  pageTransition: pageTransitionStoreTypes,
  linkek: linkekStoreTypes,
};
let app = mergeModules([
  szervezetek,
  hirKategoriak,
  fooldalData,
  fooldalDataDesktop,
  appSettings,
  isDrawerOpened,
  user,
  pageTransition,
  linkek,
]);

export { app, AppStoreTypes };
